import script from "./CallRoom.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallRoom.vue?vue&type=script&setup=true&lang=ts"

import "./CallRoom.vue?vue&type=style&index=0&id=0835792e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0835792e"]])

export default __exports__